
import './EpisodePaneItem.scss';
import './EpisodePaneOpenItem.scss';
import { SeriesEpisode } from './SeriesEpisodesPopup';
export function EpisodePaneItem(props: {
    data: SeriesEpisode,
    opened: boolean,
    current: boolean,
    onPlay: () => void,
    onOpen: () => void
}) {
    return (
        <div className="ltr-wpdr76 thisone" data-uia="episode-pane-item">
            <div aria-label={props.data.name} tabIndex={0} className="ltr-2t1w26">
            </div>
            <div className="ltr-70qvj9" onClick={() => {
                if (props.onOpen) {
                    props.onOpen();
                }
            }}>
                <span datauia="episode-pane-item-number" className="ltr-1v7n2a4">{props.data.episodeNumber}</span>
                <span className="ltr-eatmt0">{props.data.name}</span>
                <progress style={{ visibility: 'hidden' }} max="1" className="ltr-fnwh81">
                </progress>
            </div>
            <div data-uia="episode-pane-item-preview-closed" className="ltr-11cc9od" style={props.opened ? {} : { "display": "none" }}>
                <div className="ltr-9shd9d" style={{ "backgroundImage": `url('${props.data.thumbnail}')` }}>
                    <button aria-hidden="true" onClick={() => {
                        props.onPlay()
                    }} className="play-button ltr-13d37r9" tabIndex="-1">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                            className="Hawkins-Icon Hawkins-Icon-Standard">
                            <path d="M4 2.69127C4 1.93067 4.81547 1.44851 5.48192 1.81506L22.4069 11.1238C23.0977 11.5037 23.0977 12.4963 22.4069 12.8762L5.48192 22.1849C4.81546 22.5515 4 22.0693 4 21.3087V2.69127Z" fill="currentColor">
                            </path>
                        </svg>
                    </button>
                    <div className="ltr-15a9zql">
                    </div>
                </div>
                <span className="ltr-wi2fqu">{props.data.description}</span>
            </div>
        </div>
    );
}

export function EpisodePaneOpenItem(props: { data: SeriesEpisode }) {
    return (
        <div className="ltr-1k79dkt" data-uia="episode-pane-item ">
            <div aria-label={props.data.name} tabIndex={0} className="ltr-2t1w26">
            </div>
            <div className="ltr-70qvj9">
                <span datauia="episode-pane-item-number" className="ltr-1v7n2a4">{props.data.episodeNumber}</span>
                <span className="ltr-eatmt0">{props.data.name}</span>
                <progress style={{ visibility: 'hidden' }} max="1" className="ltr-fnwh81">
                </progress>
            </div>
            <div data-uia="episode-pane-item-preview-open" className="ltr-11cc9od">
                <div className="ltr-9shd9d" style={{ "backgroundImage": `url('${props.data.thumbnail}')` }}>
                    <div className="ltr-15a9zql">
                    </div>
                </div>
                <span className="ltr-wi2fqu">
                </span>
            </div>
        </div>
    );
}